export function set_day_name(number) {
  switch (number) {
    case 6:
      return "شنبه";
    case 0:
      return "یکشنبه";
    case 1:
      return "دوشنبه";
    case 2:
      return "سه شنبه";
    case 3:
      return "چهار شنبه";
    case 4:
      return "پنجشنبه";
    case 5:
      return "جمعه";
    default:
      break;
  }
}
export default set_day_name;
